<template>
	<div class="basis-page-cls" v-loading="loading">
		<section class="basis-cls_table">
			<div class="header">
                <span class="title">资源库设置</span>
            </div>
			<div class="table">
				<!-- <table-pagination
					pagination
					:data="list"
					:column="column"
					:total="total"
					:page.sync="listQuery.pageNum"
					:limit.sync="listQuery.pageSize"
					@pagination="getList" /> -->
				<table-pagination
					:data="list"
					:column="column" />
			</div>
		</section>
		<el-dialog title="资源库设置" :modal-append-to-body="false" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="875px">
			<TouchIn v-if="dialogFormVisible" @onupdate="getList" :row="row" @closeEmitChange="closeEmitChange" />
		</el-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import TouchIn from './TouchIn';
export default {
	components: {TouchIn},
	computed: {
		...mapGetters([
			'userInfo',
		])
	},
	data() {
		return {
			column: [
				{ label: '资源库', prop: 'name' },
				{ 
					label: '库类型', 
					render: (h, scope) => {
                        return <el-tag size="mini" type={scope.row.type == '2' ? '' : 'warning'}>{scope.row.type == '2' ? '流程' : '知识'}</el-tag>
                    } 
				},
				{ label: '简介', prop: 'remark' },
				{
                    label: '操作',
                    prop: 'cation',
                    align: 'center',
                    width: 80,
                    fixed: 'right',
                    render: (h, scope) => {
						return (
							<div>
								<el-button 
									onClick={() => this.handleView(scope.row)}
									type="text">
									设置
								</el-button>
							</div>
						)
                    }
                }
            ],
			listQuery: {
				pageNum: 1,
				pageSize: 10,
				projectId: ''
			},
			total: 0,
			list: [],
			loading: false,
			dialogFormVisible: false,
			row: ''
		}
	},
	async created() {
		await this.getList();
	},
	methods: {
		getList() {
			this.loading = true;
			this.listQuery.projectId = this.$store.getters.userInfo.brandIdentify;
			this.$api.apiPostKnowledgeResourceJWTByList({right: 6}).then(response => {
				if(response.errcode != 0) {
					this.loading = false;
					return;
				}
				this.list = response.data || [];
				this.loading = false;
			});
		},
		handleView(row) {
			this.row = row;
			this.dialogFormVisible = true;
		},
		closeEmitChange() {
			this.dialogFormVisible = false;
			this.getList();
		}
	}
}
</script>